import { Position } from './position.model';

export class GeoPolygon {

    public points: Position[];

    constructor(obj?: Partial<GeoPolygon>) {
        Object.assign(this, obj);
    }

}
